import React, { Component } from 'react'

export default class NotFound extends Component {
	render() {
		return (
			<div className="body_container padded_top padded_bottom">
				<h1 className="no-margin">Page not found</h1>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/NotFound.js